import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Chip,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from "@mui/material";
import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
	ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";
import { Tabs } from "../../components/tabs";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { receiveUsers } from "../../../state/user/actions";
import { Notice } from "../../components/notice";

const API_HOST = CONFIG.modules["accounts"].host;

const items = {
	Employees: {
		name: "Employees",
		view: "",
	},
};

const fields = [
	{
		type: "text",
		label: "Name",
		required: true,
		name: "name",
	},
	{
		type: "select",
		label: "Gender",
		option: { key: "genders", value: "_id", label: "name" },
		required: true,
		name: "gender",
	},
	{
		type: "date",
		label: "Birthday",
		required: true,
		name: "dob",
		defaultValue: dayjs(),
	},
	{
		type: "text",
		label: "Phone",
		required: true,
		name: "phone",
	},
	{
		type: "text",
		label: "Email",
		required: true,
		name: "email",
	},
	{
		type: "password",
		label: "Password",
		required: true,
		name: "password",
	},
	{
		type: "textArea",
		label: "Permanent Address",
		required: true,
		name: "permanentAddress",
	},
	{
		type: "textArea",
		label: "Current Address",
		required: true,
		name: "currentAddress",
	},
	// {
	// 	type: "password",
	// 	label: "Password",
	// 	required: true,
	// 	name: "password",
	// },
	// {
	// 	type: "group",
	// 	items: [
	// 		{
	// 			type: "date",
	// 			label: "Date of Birth",
	// 			required: true,
	// 			name: "dob",
	// 			defaultValue: dayjs(),
	// 		},
	// {
	// 	type: "date",
	// 	label: "Date of Joining",
	// 	required: true,
	// 	name: "dateOfJoining",
	// 	defaultValue: dayjs(),
	// },
	// ],
	// },
	// {
	// 	type: "select",
	// 	label: "Employement Type",
	// 	option: { key: "employementTypes", value: "_id", label: "name" },
	// 	required: true,
	// 	name: "employementType",
	// },

	// {
	// 	type: "select",
	// 	label: "Department Type",
	// 	option: { key: "department_types", value: "_id", label: "name" },
	// 	required: true,
	// 	defaultValue: "Core",
	// 	name: "department_type",
	// },
	// {
	// 	type: "select",
	// 	label: "Departments",
	// 	option: { key: "DepartmentsFiltered", value: "_id", label: "name" },
	// 	required: true,
	// 	name: "departments",
	// 	multiple: true,
	// },

	// {
	//     type: 'select',
	//     label: 'Roles',
	//     required: true,
	//     name: 'roles',
	//     multiple: true,
	//     option: { key: 'roles', value: '_id', label: 'name' }

	// },

	// {
	// 	type: "select",
	// 	label: "Designation",
	// 	option: { key: "Designations", value: "_id", label: "name" },
	// 	required: true,
	// 	name: "designation",
	// 	multiple: true,
	// },
	// {
	// 	type: "select",
	// 	label: "Assigned Roles",
	// 	option: { key: "TaskTypes", value: "_id", label: "name" },
	// 	required: true,
	// 	name: "assignedRoles",
	// 	multiple: true,
	// },

	// {
	//     type: 'select',
	//     label: 'Languages',
	//     option: { key: 'Languages', value: '_id', label: 'name' },
	//     name: 'languages',
	//     multiple: true
	// },
	// {
	//     type: 'select',
	//     label: 'Districts',
	//     option: { key: 'Districts', value: '_id', label: 'name' },
	//     name: 'district'
	// },
	// {
	//     type: 'select',
	//     label: 'Reporting Manager',
	//     option: { key: 'users', value: '_id', label: 'name' },
	//     name: 'reportingManager'
	// },
	// {
	//     type: 'select',
	//     label: 'POC',
	//     option: { key: 'users', value: '_id', label: 'name' },
	//     name: 'pocForLeaves'
	// },
];

const emergencyContactfields = [
	{
		type: "text",
		label: "Name",
		required: true,
		name: "emergencyContactName",
	},
	{
		type: "text",
		label: "Relation",
		required: true,
		name: "emergencyContactRelation",
	},
	{
		type: "text",
		label: "Contact Number",
		required: true,
		name: "emergencyContactNumber",
	},
];

const employementDetails = [
	{
		type: "date",
		label: "Date of Joining",
		required: true,
		name: "dateOfJoining",
		defaultValue: dayjs(),
	},
	{
		type: "select",
		label: "Departments",
		option: { key: "Departments", value: "_id", label: "name" },
		required: true,
		name: "departments",
		multiple: true,
	},
	{
		type: "select",
		label: "Designation",
		option: { key: "Designations", value: "_id", label: "name" },
		required: true,
		name: "designation",
		multiple: true,
	},
	{
		type: "select",
		label: "Assigned Roles",
		option: { key: "TaskTypes", value: "_id", label: "name" },
		required: true,
		name: "assignedRoles",
		multiple: true,
	},
	{
		type: "select",
		label: "Add Languages",
		option: { key: "Languages", value: "_id", label: "name" },
		name: "languages",
		multiple: true,
	},
	{
		type: "select",
		label: "Employement Type",
		option: { key: "employementTypes", value: "_id", label: "name" },
		required: true,
		name: "employementType",
	},

	// {
	// 	type: "select",
	// 	label: "Department Type",
	// 	option: { key: "department_types", value: "_id", label: "name" },
	// 	required: true,
	// 	defaultValue: "Core",
	// 	name: "department_type",
	// },

	// {
	// 	type: "select",
	// 	label: "Roles",
	// 	required: true,
	// 	name: "roles",
	// 	multiple: true,
	// 	option: { key: "roles", value: "_id", label: "name" },
	// },

	// {
	//     type: 'select',
	//     label: 'Districts',
	//     option: { key: 'Districts', value: '_id', label: 'name' },
	//     name: 'district'
	// },
	// {
	//     type: 'select',
	//     label: 'Reporting Manager',
	//     option: { key: 'users', value: '_id', label: 'name' },
	//     name: 'reportingManager'
	// },
	// {
	//     type: 'select',
	//     label: 'POC',
	//     option: { key: 'users', value: '_id', label: 'name' },
	//     name: 'pocForLeaves'
	// },
];

const authorisationHierarchy = [
	{
		type: "switch",
		label: "Is PMU",
		name: "isPMU",
		defaultValue: false,
	},
	{
		type: "switch",
		label: "Leave for POC",
		name: "leaveForPOC",
		defaultValue: false,
	},
	{
		type: "select",
		label: "Reporting Manager",
		option: { key: "users", value: "_id", label: "name" },
		name: "reportingManager",
	},
	{
		type: "select",
		label: "POC",
		option: { key: "users", value: "_id", label: "name" },
		name: "pocForLeaves",
	},
];

export const EmployeePMU = (props) => {
	const {
		roles,
		user,
		users,
		Designations,
		Departments,
		Languages,
		Districts,
		TaskTypes,
		map,
	} = useSelector((state) => state.user || {});
	const userStore = useSelector((state) => state.user || {});

	const history = useHistory();
	const dispatch = useDispatch();

	const [DepartmentsFiltered, setDepartmentsFiltered] = useState([]);
	const [active, setActive] = useState("");
	const [data, setData] = useState((users || []).filter((u) => u.isPMU));
	const [open, setOpen] = useState(false);
	const [action, setAction] = useState("new");
	const [saved, setSaved] = useState(null);
	const [index, setIndex] = useState(null);
	const [openConfirm, setOpenConfirm] = useState(false);

	const [formData, setFormData] = useState(
		getFormState([
			...fields,
			...employementDetails,
			...authorisationHierarchy,
			...emergencyContactfields,
		])
	);
	console.log(formData);

	const [savedMessage, setSavedMessage] = useState(false);

	useEffect(() => {
		// console.log(DepartmentsFiltered)
		// console.log(formData, DepartmentsFiltered)
	}, [DepartmentsFiltered]);

	useEffect(() => {
		if (Array.isArray(users)) setData(users.filter((u) => u.isPMU));
	}, [users]);

	useEffect(() => {
		// if (formData.department_type) {
		// 	setDepartmentsFiltered(
		// 		(Departments || []).filter((e) => e.type == formData.department_type)
		// 	);
		// 	const newFormData = { ...formData };
		// 	formData.departments = [];
		// 	setFormData({ ...newFormData, departments: [] });
		// 	console.log("hre", formData);
		// }
	}, [formData.department_type]);

	useEffect(() => {
		console.log("ff", formData);
	}, [formData]);

	useEffect(() => {}, [active]);

	useEffect(() => {}, [Designations]);

	useEffect(() => {}, [userStore]);

	const handleSubmit = () => {
		// const toSave = { ...formData };

		// axios
		// 	.post(API_HOST, {
		// 		user: { ...toSave },
		// 	})
		// 	.then((resp) => {
		// 		if (resp.data && resp.data.success) {
		// 			setOpen(false);
		// 			setData([resp.data.data, ...data]);
		// 			dispatch(receiveUsers([resp.data.data, ...data]));
		// 			setSavedMessage("Great! New Employee Added");
		// 			setTimeout(() => {
		// 				setSavedMessage(null);
		// 			}, 2000);
		// 		}
		// 	})
		// 	.catch((e) => {
		// 		console.log(e);
		// 	});
	};

	const handleEdit = () => {
		// if (formData.password == "") {
		// 	delete formData.password;
		// }
		// const toSave = { ...formData };

		// axios
		// 	.put(API_HOST + `/${saved._id}`, {
		// 		user: toSave,
		// 	})
		// 	.then((resp) => {
		// 		if (resp.data && resp.data.success) {
		// 			setOpen(false);
		// 			data[index] = resp.data.user;
		// 			setData([...data]);
		// 			dispatch(receiveUsers([...data]));
		// 			setSavedMessage("Great! Employee Saved");
		// 			setTimeout(() => {
		// 				setSavedMessage(null);
		// 			}, 2000);
		// 		}
		// 	})
		// 	.catch((e) => {
		// 		console.log(e);
		// 	});
	};

	const handleDelete = () => {
		// axios
		// 	.delete(API_HOST + "/" + saved._id)
		// 	.then((resp) => {
		// 		if (resp.data && resp.data.success) {
		// 			setOpenConfirm(false);
		// 			data.splice(index, 1);
		// 			setData([...data]);
		// 			dispatch(receiveUsers([...data]));
		// 		}
		// 	})
		// 	.catch((e) => {
		// 		console.log(e);
		// 	});
	};
	return (
		<>
			{/* <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} /> */}

			{savedMessage && <Notice text={savedMessage} />}

			{/* <ToolBar
				name={active}
				buttons={[
					{
						name: "Add new",
						onClick: () => {
							setAction("new");
							setFormData(getFormState([...fields, ...employementDetails, ...authorisationHierarchy, ...emergencyContactfields]));
							setOpen(true);
						},
					},
				]}
			/> */}
			<Box sx={{ mt: 2 }}>
				<Grid
					data={data}
					columns={[
						{
							id: "name",
							label: "Name",
							minWidth: 100,
							format: (data, row) => {
								return (
									<Typography
										variant={"p"}
										sx={{ cursor: "pointer" }}
										onClick={() => {
											history.push(
												`/hr/employee-management/detail?id=${(row || {})._id}`
											);
										}}
									>
										{data}
									</Typography>
								);
							},
						},
						// { id: 'email', label: 'Email', minWidth: 170 },
						{ id: "uuid", label: "Emp .Code", minWidth: 110 },
						{
							id: "departments",
							label: "Departments",
							width: 100,
							format: (data, row) => {
								return (
									<Box>
										{data
											? data.map((d, i) => {
													// return <Chip key={i} label={`${d.type}: ${d.name}`} variant="outlined" sx={{mr:1, mt:1}}/>

													return (
														<Chip
															key={i}
															label={`${d.name}`}
															color={d.type == "Core" ? "success" : "primary"}
															variant="outlined"
															sx={{
																mr: 1,
																mt: 1,
																// borderColor: d.type == 'Core'?'#3f50b5':'#f44336',
																// color: d.type == 'Core'?'#3f50b5':'#f44336'
															}}
														/>
													);
											  })
											: ""}
									</Box>
								);
							},
						},
						
						{
							id: "reportingManager",
							label: "Reporting Manager",
							minWidth: 130,
							format: (data, row) => {
								return map.users[data] ? (
									<Typography variant={"p"} sx={{ cursor: "pointer" }}>
										{map.users[data].name}
									</Typography>
								) : (
									""
								);
							},
						},
						{
							id: "pocForLeaves",
							label: "POC for leaves",
							minWidth: 130,
							format: (data, row) => {
								return map.users[data] ? (
									<Typography variant={"p"} sx={{ cursor: "pointer" }}>
										{map.users[data].name}
									</Typography>
								) : (
									""
								);
							},
						},
						{ id: 'roles', label: 'Designation', minWidth: 170, format: (data, row) => {
							return Array.isArray(data)?data.map((r,i)=> {
								const m = map.Roles
								return (
									<Chip
									key={i}
									label={`${m[r]?.name}`}
									// color={d.type == "Core" ? "success" : "primary"}
									variant="outlined"
									sx={{
										mr: 1,
										mt: 1,
									   
									}}
								/>
								)
							}):''
						} },
						// {
						// 	id: "designation",
						// 	label: "Designations",
						// 	minWidth: 170,
						// 	format: (data, row) => {
						// 		return data
						// 			? data.map((d, i) => {
						// 					return (
						// 						<Chip
						// 							key={i}
						// 							label={`${d.name}`}
						// 							variant="outlined"
						// 							sx={{ mr: 1, mt: 1 }}
						// 						/>
						// 					);
						// 			  })
						// 			: "";
						// 	},
						// },
						// {
						// 	id: "assignedRoles",
						// 	label: "Assigned Roles",
						// 	minWidth: 100,
						// 	format: (data, row) => {
						// 		return data
						// 			? data.map((d, i) => {
						// 					return (
						// 						<Chip
						// 							key={i}
						// 							label={`${d.name}`}
						// 							variant="outlined"
						// 							sx={{ mr: 1, mt: 1 }}
						// 						/>
						// 					);
						// 			  })
						// 			: "";
						// 	},
						// },
					]}
					// actions={[
					// 	{
					// 		name: "Edit",
					// 		onClick: (id) => {
					// 			setIndex(id);
					// 			setSaved(data[id]);
					// 			const newData = { ...data[id] };
					// 			newData.password = "";
					// 			newData.dob = dayjs(newData.dob);
					// 			newData.dateOfJoining = dayjs(newData.dateOfJoining);
					//             // newData.isPMU = 'on'//newData.isPMU? "on":"off"
					//             // newData.leaveForPOC = 'on'//newData.leaveForPOC? "on":"off"
					//             // console.log('tot',newData)
					// 			if (newData.departments) {
					// 				newData.departments = newData.departments.map((d) => d._id);
					// 			}
					// 			if (newData.designation) {
					// 				newData.designation = newData.designation.map((d) => d._id);
					// 			}
					// 			if (newData.assignedRoles) {
					// 				newData.assignedRoles = newData.assignedRoles.map(
					// 					(d) => d._id
					// 				);
					// 			}
					// 			setFormData(newData);
					// 			setAction("edit");
					// 			setOpen(true);
					// 		},
					// 	},
					// 	{
					// 		name: "Delete",
					// 		onClick: (id) => {
					// 			setIndex(id);
					// 			setSaved(data[id]);
					// 			setOpenConfirm(true);
					// 		},
					// 	},
					// ]}
				></Grid>
			</Box>
			<Modal
				open={open}
				handleClose={() => {
					setOpen(false);
				}}
				head={`${action == "new" ? "New Employee Data" : "Edit"} ${active}`}
				buttons={[
					{
						name: "Cancel",
						onClick: () => {
							// setOpen(false);
							if (window.confirm("Are you sure you want to cancel?")) {
								setSavedMessage("Employee Data not created!");
								setTimeout(() => {
									setSavedMessage(null);
								}, 2000);
								setOpen(false);
							}
						},
					},
					{
						name: action == "new" ? "Create" : "Save",
						onClick: () => {
							switch (action) {
								case "new":
									handleSubmit();
									break;
								case "edit":
									setDepartmentsFiltered(
										(Departments || []).filter(
											(e) => e.type == formData.department_type
										)
									);
									handleEdit();
									break;
								default:
									break;
							}
						},
					},
				]}
			>
				{action == "edit" && (
					<Typography variant="p" color="grey">
						{"ID: " + saved._id}
					</Typography>
				)}
				{Array.isArray(fields) && (
					<>
						<Accordion defaultExpanded={true}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography>Personal Details</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<FormA
									fields={fields}
									data={{
										genders: [
											{
												_id: "male",
												name: "Male",
											},
											{
												_id: "female",
												name: "Female",
											},
										],
									}}
									onChange={(name, value, multiple) => {
										formData[name] = value;
										// if (name == "department_type") {
										// 	setFormData({ ...formData, departments: [] });
										// } else {
										// 	setFormData({ ...formData });
										// }
										setFormData({ ...formData });
									}}
									state={formData || {}}
								/>
								<Typography>Emergency Contact Person</Typography>
								<FormA
									fields={emergencyContactfields}
									onChange={(name, value, multiple) => {
										formData[name] = value;
										setFormData({ ...formData });
									}}
									state={formData || {}}
								/>
							</AccordionDetails>
						</Accordion>

						<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography>Employment Details</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<FormA
									fields={employementDetails}
									data={{
										roles,
										Designations,
										Districts,
										Languages,
										Departments,
										DepartmentsFiltered,
										users,
										TaskTypes,
										department_types: [
											{
												_id: "Core",
												name: "Core",
											},
											{
												_id: "Project Based",
												name: "Project Based",
											},
										],
										employementTypes: [
											{
												_id: "Full Time",
												name: "Full Time",
											},
											{
												_id: "Part Time",
												name: "Part Time",
											},
										],
									}}
									onChange={(name, value, multiple) => {
										// console.log(name, value)
										formData[name] = value;
										// if (name == "department_type") {
										// 	setFormData({ ...formData, departments: [] });
										// } else {
										// 	setFormData({ ...formData });
										// }
									}}
									state={formData || {}}
								/>
							</AccordionDetails>
						</Accordion>

						<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography>Authorisations and Hierarchy</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<FormA
									fields={authorisationHierarchy}
									data={{
										users,
										TaskTypes,
									}}
									onChange={(name, value, multiple) => {
										// console.log(name, value)
										formData[name] = value;
										setFormData({ ...formData });
									}}
									state={formData || {}}
								/>
							</AccordionDetails>
						</Accordion>
					</>
				)}
			</Modal>

			<Modal
				open={openConfirm}
				handleClose={() => {
					setOpen(false);
				}}
				head={`${"Delete"} ${active}`}
				desc={`Please confirm to delete the following ${active}?`}
				buttons={[
					{
						name: "Cancel",
						onClick: () => {
							setOpenConfirm(false);
						},
					},
					{
						name: "Delete",
						onClick: () => {
							handleDelete();
						},
					},
				]}
			>
				{saved && (
					<Box>
						<Typography variant="p" color="grey">
							{"ID: " + saved._id}
						</Typography>
						<br></br>
						<Typography variant="p" color="grey">
							{"Name: " + saved.name}
						</Typography>
					</Box>
				)}
			</Modal>
		</>
	);
};
